import { render, staticRenderFns } from "./LearningCategoryIndex.vue?vue&type=template&id=59bb441d"
import script from "./LearningCategoryIndex.vue?vue&type=script&lang=js"
export * from "./LearningCategoryIndex.vue?vue&type=script&lang=js"
import style0 from "./LearningCategoryIndex.vue?vue&type=style&index=0&id=59bb441d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports